import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit,
  ViewContainerRef,
  viewChild
} from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-tab-dynamic',
    templateUrl: './tab-dynamic.component.html',
    styleUrls: ['./tab-dynamic.component.scss'],
    standalone: false
})
export class TabDynamicComponent implements OnInit, AfterViewInit {
  readonly container = viewChild('dynamicContainer', { read: ViewContainerRef });

  @Input('tabTitle') title: string;
  @Input('tabName') name: string;
 // @Input('param') param: number;
 // @Input('query') query: number;

  @Input() isMainMenu: boolean = true;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() component;
  @Input() dataContext;

  loading$: Observable<boolean>;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    public changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadComponent();
  }
  ngAfterViewInit(): void {}

  public loadComponent() {
    if (!this.component) return;
    this.container().clear();
    const componentFactory =
      this._componentFactoryResolver.resolveComponentFactory(this.component);
    let dynamicComp = this.container().createComponent(componentFactory);
  }
}
